module.exports = __webpack_public_path__ + "static/media/Adobe_Corporate_Horizontal_Lockup_Red_RGB.901f3f10.svg";